import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { CartSummaryCosts } from "@temp/@next/components/organisms";
import * as React from "react";
import { CartTable, NotFound } from "../../../components";

var extractOrderLines = function extractOrderLines(lines) {
  return lines.map(function (line) {
    return _objectSpread({
      quantity: line.quantity,
      totalPrice: _objectSpread({}, line.unitPrice, {
        currency: line.unitPrice.currency,
        gross: _objectSpread({
          amount: line.quantity * line.unitPrice.gross.amount
        }, line.unitPrice.gross),
        net: _objectSpread({
          amount: line.quantity * line.unitPrice.net.amount
        }, line.unitPrice.net)
      })
    }, line.variant, {
      name: line.productName,
      selectedProductAttributes: line.selectedProductAttributes
    });
  }).sort(function (a, b) {
    return b.id.toLowerCase().localeCompare(a.id.toLowerCase());
  });
};

var Page = function Page(_ref) {
  var guest = _ref.guest,
      order = _ref.order,
      hideFooter = _ref.hideFooter;
  return order ? React.createElement(React.Fragment, null, React.createElement(CartTable, {
    lines: extractOrderLines(order.lines)
  }), !hideFooter && React.createElement("div", {
    className: "account-order-details__footer"
  }, React.createElement(CartSummaryCosts, {
    subtotal: order.subtotal,
    promoCode: order.discount && {
      gross: order.discount,
      net: order.discount
    },
    shipping: order.shippingPrice,
    total: order.total
  }))) : React.createElement(NotFound, null);
};

Page.displayName = "OrderDetailsPage";
export default Page;